import { useEffect, useState } from 'react';
import { Alert, Button } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLocale } from '../../i18n/LocaleContext';
import { listImports } from '../../services/onboarding.service';

export default function ImportNotifications() {
  const { user } = useAuth();
  const { t } = useLocale();
  const { pathname } = useLocation();
  const [count, setCount] = useState(0);
  useEffect(() => {
    setCount(0);
    if (user?.role !== 'admin') {
      return;
    }
    let active = true;
    let fetching = false;
    const check = async () => {
      if (fetching) return;
      fetching = true;
      try {
        const jobs = await listImports();
        if (active)
          setCount(
            jobs.filter(
              (job) => ['complete', 'partial', 'failed'].includes(job.status) && !job.readAt,
            ).length,
          );
      } catch {
        /* The job page provides detailed request failures. */
      } finally {
        fetching = false;
      }
    };
    void check();
    const timer = window.setInterval(() => void check(), 15000);
    return () => {
      active = false;
      window.clearInterval(timer);
    };
  }, [user?.id, user?.role, pathname]);
  return count > 0 && pathname !== '/imports' ? (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      action={
        <Button component={Link} to="/imports">
          {t('onboarding.jobs')}
        </Button>
      }
    >
      {t('onboarding.notifications', { count: String(count) })}
    </Alert>
  ) : null;
}
